import client from '@libs/HttpClient';
class RecruitmentSkillServices {
  static listRecruitmentSkill(request) {
    const page_no = request.queryKey[1];
    const searchText = request.queryKey[2];
    const status = request.queryKey[3];
    return client.get(
      `/recruitment-candidate-skills/?search=${searchText}&page=${page_no}&status=${status}`,
      request
    );
  }
  static addRecruitmentSkill(request) {
    return client.post('/recruitment-candidate-skills', request);
  }
  static showRecruitmentSkill(params) {
    return client.get(`/recruitment-candidate-skills/${params}`);
  }
  static viewRecruitmentSkill(params) {
    return client.get(`/recruitment-candidate-skills/${params}/edit`);
  }
  static updateRecruitmentSkill(request) {
    return client.put(`/recruitment-candidate-skills/${request.id}`, request);
  }
  static deleteRecruitmentSkill(request) {
    return client.delete(`/recruitment-candidate-skills/${request.id}`, request);
  }
  static changeStatusRecruitmentSkill(request) {
    return client.patch(`/recruitment-candidate-skills/change-status/${request.id}`, request);
  }
}
export { RecruitmentSkillServices };
